module.exports = __webpack_public_path__ + "img/language_w.677a703f.svg";